import React from 'react'
import { AttachJurisdictionFlowProvider } from './context/AttachJurisdictionFlowProvider'
import { AttachJurisdictionFlowMain } from './components/AttachJurisdictionFlowMain'
import { useRuleDetailContextValue } from '../../context/RuleDetailProvider'

export const AttachJurisdictionFlow = () => {
  const {
    state: { id: ruleId },
  } = useRuleDetailContextValue()

  return (
    <AttachJurisdictionFlowProvider ruleId={ruleId}>
      <AttachJurisdictionFlowMain />
    </AttachJurisdictionFlowProvider>
  )
}
